module.exports = __webpack_public_path__ + "static/media/Stop_Cheque_Payment.dc401bf8.svg";